export { MeetingPage as default } from '@/components/pages/Ir/Stock/Meeting'
